import styled from 'styled-components';
import Layout from 'antd/lib/layout';
import Select from 'antd/lib/select';
import { Link } from 'react-router-dom';

const { Content } = Layout;

export const MapsPage = styled(Content)`
  margin: 0 auto;
  max-width: 1000px;
  padding: 16px;
  width: 100%;
`;

export const MapHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;

  @media (max-width: 900px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  color: #1b2b43;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.15;
  margin: 0;

  @media (max-width: 900px) {
    font-size: 36px;
  }
`;

export const HeaderActions = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;

  @media (max-width: 900px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const SearchInput = styled.div`
  flex: 0 0 320px;
  width: 320px;

  @media (max-width: 900px) {
    flex: 1 1 100%;
    width: 100%;
  }
`;

export const Toolbar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

export const SortSelect = styled(Select)`
  flex: 0 0 230px;
  min-width: 230px;
`;

export const MapList = styled.div`
  border: 1px solid #d8e0ec;
  border-radius: 8px;
  overflow: hidden;
`;

export const ZeroState = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 36px 20px;
  text-align: center;
`;

export const ZeroStateTitle = styled.h3`
  color: #1b2b43;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

export const ZeroStateDescription = styled.p`
  color: #4c5a6d;
  font-size: 14px;
  margin: 0;
`;

export const ZeroStateActions = styled.div`
  margin-top: 4px;
`;

export const MapItem = styled.div`
  align-items: stretch;
  background: #fff;
  border-left: 4px solid transparent;
  border-bottom: 1px solid #e8edf5;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 18px 20px;

  &:last-child {
    border-bottom: 0;
  }
`;

export const MapContent = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
`;

export const MapName = styled(Link)`
  color: #1b2b43;
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 6px;

  &:hover {
    color: #1b2b43;
    text-decoration: underline;
  }
`;

export const MapDescription = styled.p`
  color: #344154;
  font-size: 14px;
  margin: 0 0 10px;
`;

export const MapBody = styled.div`
  margin-top: auto;
`;

export const MapSections = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 14px;
  }
`;

export const MapSection = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;

export const BoundariesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BoundaryPill = styled.span`
  background: #f5f5f5;
  border-radius: 999px;
  color: #595959;
  display: inline-flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  padding: 6px 12px;
`;

export const DatasetsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SectionTitle = styled.div`
  color: #1b2b43;
  font-size: 12px;
  font-weight: 500;
  margin: 0 0 8px;
  text-transform: uppercase;
`;

export const MapDatasetRow = styled.div`
  .ant-badge-status-text {
    color: #4c5a6d;
    font-size: 12px;
    margin-left: 8px;
  }
`;

export const LastUpdatedText = styled.span`
  color: #4c5a6d;
  font-size: 12px;
  white-space: nowrap;
  text-align: right;
`;

export const ActionsRow = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  padding-top: 4px;

  .ant-btn {
    height: 36px;
    width: 36px;
    padding: 0;
  }

  .anticon {
    font-size: 14px;
  }
`;

export const ActionsColumn = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
`;
